module.exports = __webpack_public_path__ + "static/img/14areaA_4.20715fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/14areaA_4.png
// module id = 1008
// module chunks = 1